import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { AppConfig } from "../../../../environments/environment";
import { firstValueFrom } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

function formatDateTime(date: Date): string {
  const y = date.getFullYear();
  const m = date.getMonth() + 1; // Month is zero-based
  const d = date.getDate();
  const hr = date.getHours();
  const min = date.getMinutes();

  return `${y}-${m.toString().padStart(2, '0')}-${d.toString().padStart(2, '0')}T${hr.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
}

function convertLocalToISO(strLocalTime: string) {
  const date = new Date(strLocalTime);
  const isoString = date.toISOString();
  return isoString;
}

@Component({
  selector: "app-weather-query",
  templateUrl: "./weather-query.component.html",
  styleUrls: ["./weather-query.component.scss"],
})
export class WeatherQueryComponent implements OnInit {
  @Input() latitude!: number;
  @Input() longitude!: number;
  @Input() startDate: Date = new Date(new Date().setHours(new Date().getHours() - 24));
  @Input() endDate: Date = new Date();
  @Input() searchRadiusMiles: number = 50;
  @Input() maxChosenStations: number = 2;
  @Input() maxQueryStations: number = 20;
  @Input() weatherServiceName: string = 'NOAA';
  weatherForm: FormGroup;
  weatherServiceNames = ['NOAA', 'VisualCrossing']; //, 'NCDC NOAA']; // NCDC not ready... requires ftp file search on server
  currentDate = new Date();
  weatherResult: any;
  errorMsg = '';
  bProcessing = false;

  constructor(
    private httpClient: HttpClient,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.weatherForm = this.fb.group({
      startDate: [formatDateTime(this.startDate), Validators.required],
      endDate: [formatDateTime(this.endDate), Validators.required],
      searchRadiusMiles: [this.searchRadiusMiles, Validators.required],
      maxChosenStations: [this.maxChosenStations, Validators.required],
      maxQueryStations: [this.maxQueryStations, Validators.required],
      latitude: [this.latitude, Validators.required],
      longitude: [this.longitude, Validators.required],
      weatherServiceName: [this.weatherServiceName, Validators.required]
    });
  }

  async getWeather() {
    this.errorMsg = '';
    this.weatherResult = null;
    if (this.weatherForm.valid) {
      const urlBasePath = `${AppConfig.apiUrl}`;
      const formData = this.weatherForm.value;
      const urlPath = `${urlBasePath}/weather/findLatLngWeather`;
      console.log('findLatLngWeather() params: ', formData);
      try {
        this.bProcessing = true;
        const params = {
          latitude: formData.latitude,
          longitude: formData.longitude,
          radiusMiles: formData.searchRadiusMiles,
          stationLimit: formData.maxChosenStations,
          maxQueryStations: formData.maxQueryStations,
          startDate: convertLocalToISO(formData.startDate),
          endDate: convertLocalToISO(formData.endDate),
          weatherServiceName: formData.weatherServiceName,
        };
        console.log('findLatLngWeather() params: ', params);
        const result: any = await firstValueFrom(
          this.httpClient.get(urlPath, {
            params
          })
        );
        this.weatherResult = result.data;
      } catch (error) {
        this.errorMsg = `Weather request error. ` + error?.message;
        console.error("findLatLngWeather() error: " + error?.message);
        throw error;
      } finally {
        this.bProcessing = false;
      }
    } else {
      console.error('Form is not valid!');
    }
  }
}
